import ResetPasswordForm from "../../features/resetPassword/ResetPasswordForm"
import PageLoader from "../../components/ui/pageLoader/PageLoader"
import { Suspense } from "react"
import "./Reset.scss";


function ForgotPassword() {
    return (

        <Suspense fallback={<PageLoader />}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="login-page-common-spacing">
                            <ResetPasswordForm />
                        </div>
                    </div>
                </div>
            </div>
        </Suspense>
    )
}

export default ForgotPassword